import List from "components/list";
import ProjectNameCell from "@/modules/work/projects/cells/name";
import { NameCell } from "@/components/cells/name";
import { DateTimeCell } from "components/cell/date/cell";

const repoProjectSearch = (search) => ({ project: { name: { _icontains: search.trim() } } });

export default function GithubIntegrations({ storageKey = "integrations-github", title = "Reposotries" }) {
  const columns = [
    {
      id: "project",
      header: "Project",
      accessorKey: "project",
      cell: ({ row }) => <ProjectNameCell row={{ original: row.original?.project || {} }} />,
    },
    {
      id: "repository",
      header: "Repository",
      accessorFn: (row) => row?.repository_url?.split("/").slice(-2).join("/") || "-",
      cell: (info) => (
        <span className="hover:underline">
          <NameCell {...info} />
        </span>
      ),
      href: (row) => row?.repository_url || false,
      linkProps: { target: "_blank", rel: "noreferrer" },
    },
    {
      id: "branch_count",
      header: "Branches",
      accessorKey: "branch_count",
      sortable: true,
    },
    {
      id: "employee_count",
      header: "Employees",
      accessorKey: "employee_count",
      sortable: true,
    },
    {
      id: "date_synced",
      header: "Last Synced",
      accessorKey: "date_synced",
      cell: DateTimeCell,
    },
  ];

  const fields = [
    "id",
    "project.id",
    "project.name",
    "project.logo",
    "project.project_id",
    "repository_url",
    "suffix",
    "branch_count",
    "employee_count",
    "date_synced",
  ];

  return (
    <div className="w-full">
      <div className="flex-1 h-full">
        <List
          title={title}
          endPoint="git_repositories"
          sortBy="id"
          storageKey={storageKey}
          columns={columns}
          meta={{ fields, customSearch: repoProjectSearch }}
          searchPlaceholder="Search project"
          href={(row) => row?.id && `/integrations/github/repositories/${row.id}`}
        />
      </div>
    </div>
  );
}
